import { call, put, select, takeEvery } from 'redux-saga/effects'

import * as DomainEventRest from '@app/domain/domain-events/domain-events.rest'
import type { AppAction, AppState } from '@app/state'
import * as DomainEventState from '@app/state/domain-events/state'

import type { AxiosResponse } from 'axios'

function* resubmitDomainEvent(action: AppAction) {
  if (action.type === DomainEventState.ActionType.ResubmitDomainEvent) {
    const appState: AppState = yield select((a) => a)
    try {
      const request = DomainEventRest.resubmitDomainEvent(action.id)
      const response: AxiosResponse<DomainEventRest.IResubmitDomainEventResponse> = yield call(
        request,
        appState.config.apiLocation,
        appState.auth.token,
      )

      if (response.status === 200) {
        yield put(
          DomainEventState.actions.resubmitDomainEventSucceeded(action.id),
        )
      } else {
        throw new Error()
      }
    } catch (e) {
      yield put(
        DomainEventState.actions.resubmitDomainEventFailed(
          action.id,
          'Failed to resubmit broadcast event.',
        ),
      )
    }
  }
}

function* handleResubmitDomainEvent() {
  yield takeEvery(
    DomainEventState.ActionType.ResubmitDomainEvent,
    resubmitDomainEvent,
  )
}

export const sagas = {
  handleResubmitDomainEvent,
}
